/**
 * PDP media component
 *
 * @module product-media
 * @version 2.0.0
 * @extends HTMLElement
 */

class productMediaComponent extends HTMLElement {
  constructor() {
    super();
    this.initialVariantTitle =
      this.getAttribute("data-variant-title").toUpperCase();

    let variantTitle;
    variantTitle = this.initialVariantTitle;

    // Media element.
    this.media = this.querySelector("[data-media]");

    // Thumbnails element.
    this.thumbnails = this.querySelector("[data-thumbnail-slider]");

    this.initSlider(variantTitle);
    this.isVariantChanged = 0;
    this.isThumbnailChanged = 0;
  }

  connectedCallback() {
    window.addEventListener("variant-change", (event) => {
      if (event.detail.product.id == parseInt(this.dataset.productMediaId)) {
        this.updateMedia(event.detail.product, event.detail.variant);
      }
      this.isVariantChanged = 1;
      this.isThumbnailChanged = 0;
    });

    window.addEventListener("variant-change", (event) => {
      setTimeout(() => {
        document
          .querySelector(
            `.product-media__product-thumbnails .product-media__thumbnails-item[style="display: block;"] img`
          )
          .click();
        this.updateMainSlider();
      }, 300);
    });
  }

  // Initialize the media slider.
  initSlider(variantTitle) {
    this.slider = new Swiper(this.media, {
      // preloadImages: true,
      // lazy: true,
      lazyPreloadPrevNext: 1,
      autoHeight: true,
      slidesPerView: "auto",
      loop: false,
      pagination: {
        el: ".swiper-media-pagination",
        // dynamicBullets: true,
      },
    });

    this.thumbnails.addEventListener("click", (event) => {
      this.isVariantChanged &&
        !this.isThumbnailChanged &&
        this.updateMainSlider();
      if (event.target.tagName === "IMG") {
        // Calculates the true visual index of the thumbnail in the list of visible thumbnails
        const index = Array.from(
          this.thumbnails.querySelectorAll(".product-media__thumbnails-item")
        )
          .filter((thumbnail) => thumbnail.style.display !== "none")
          .indexOf(event.target.closest("[data-thumbnail-item]"));
        const mainSliderEl = Array.from(
          document.querySelectorAll(".product-media__images .swiper-slide")
        ).filter(
          (thumbnail) =>
            Number(thumbnail.getAttribute("data-sliderIndex")) === index
        );
        const mainFixedIndex = Array.from(
          document.querySelectorAll(".product-media__images .swiper-slide")
        ).indexOf(mainSliderEl[0]);

        this.slider.slideTo(mainFixedIndex);
      }
    });

    const initialVariantTitle = this.getAttribute("data-variant-title");
    const productTitle = this.getAttribute("data-product-title");

    const defaultAlt = this.getCurrentAltForThumbnails(initialVariantTitle);
    // console.log(defaultAlt, initialVariantTitle, productTitle);

    this.updateThumbnailsVisibility(
      defaultAlt,
      initialVariantTitle,
      productTitle
    );
  }

  updateMainSlider() {
    Array.from(
      document.querySelectorAll(".product-media__images .swiper-slide")
    )
      .sort(function (a, b) {
        return (
          Number(a.getAttribute("data-sliderIndex")) -
          Number(b.getAttribute("data-sliderIndex"))
        );
      })
      .forEach(function (item) {
        document
          .querySelector(".product-media__images .swiper-wrapper")
          .appendChild(item);
      });
    this.isThumbnailChanged = 1;
  }

  processAltText(altText) {
    // Convert to uppercase and trim commas
    let str = altText.toUpperCase().trim().replace(/,/g, "");

    // List of multi-word phrases to preserve as single "cells"
    const specialPhrases = [
      "WHITE/NATURAL OAK", "NATURAL OAK", "MATTE BLACK", "SILVER GREY", "DIAMOND GREY",
      "BRUSHED NICKEL", "POLISHED CHROME", "WHITE & GREY", "MATTE ALUMINUM", "SATIN BRASS",
      "SATIN NICKEL", "ADJUSTABLE SHELVES", "SLANTED SHOE SHELVES", "SLAB DRAWERS",
      "SHAKER DRAWERS", "10 STRAIGHT SHELVES", "4 SLANTED SHELVES", "8 SLANTED SHELVES",
      "WITH SHELF", "WITHOUT SHELF", "UPPER WITH CENTER PANEL", "UPPER",
      "2 PACK", "4 PACK", "6 PACK", "3 X 42", "3 X 84", "6 X 84",
      "EXTENSION LEFT 18", "EXTENSION RIGHT 18",
      "EXTENSION 18", "STANDARD 84", "SHORT 34", "ACCENT 12", "BASE 43", "BASE LEFT 43",
      "BASE RIGHT 43", "BASE RIGHT AND LEFT 43", "UPPER 40.25", "UPPER LEFT 40.25",
      "UPPER RIGHT 40.25", "UPPER RIGHT AND LEFT 40.25", "WITH TOE-KICK", "WITH SHELF", "WITHOUT SHELF"
    ].sort((a, b) => b.length - a.length); // Sort by length so longest phrases match first

    let cells = [];

    // Extract special phrases first
    specialPhrases.forEach(phrase => {
      // Count how many times the phrase exists before removing it
      const count = str.split(phrase).length - 1;

      if (count > 0) {
        // Add it to your cells array as many times as it appeared
        for (let i = 0; i < count; i++) {
          cells.push(phrase);
        }
        // Remove all occurrences from the string
        str = str.replaceAll(phrase, "");
      }
    });

    // Split remaining words and clean up symbols/blacklist words similar to variant options processing
    const remainingWords = str.split(/\s+/).filter(w => w.length > 0);

    // Combine the preserved cells with the remaining words for the full processed alt text
    return [...cells, ...remainingWords];
  }

  processVariantOptions(variantOptions) {
    // Define blacklist (inch symbol and specific words)
    // Note: Added /g to the blacklist to catch multiple instances
    const blacklist = /\b(UNIT|FOR|WIDE|DEEP|HIGH|TOWER|HUTCH|INCH)\b|"/gi;

    return variantOptions
      .filter(opt => opt) // Remove null or undefined
      .map(opt => {
        return opt
          .toUpperCase()
          .replace(blacklist, "") // Remove the blacklisted words/symbols
          .trim()                 // Remove leading/trailing whitespace left over
          .replace(/\s+/g, ' ');  // Clean up any double spaces created by deletions
      })
      .filter(opt => opt.length > 0); // Remove any cells that became empty after cleaning
  }

  getCurrentAltForThumbnails(variantTitle) {
    let currentAlt = null;
    // console.log('currentAlt:', currentAlt);
    const thumbnailsList = Array.from(this.thumbnails.querySelectorAll("img"));

    for (let thumbnail of thumbnailsList) {
      const altText = thumbnail.getAttribute("alt") || "";
      // console.log('alt text:', altText)

      if (thumbnail.hasAttribute("alt")) {
        const altWords = this.processAltText(altText);

        if (!altText || altText === variantTitle || altWords.length > 0) {
          return altText || this.media.dataset.productTitle;
        }
      }
    }
    // console.log("Thumbnails currentAlt:", currentAlt);
    return currentAlt;
  }

  preloadImages(images) {
    images.forEach((image) => {
      const img = new Image();
      img.src = image.src;
      img.alt = image.alt;
    });
  }

  findBestMatchingAlt(variantOptionsArr, altTextArr) {
    console.log('chavi varriant arr:', variantOptionsArr, ' chavi alt text arr:', altTextArr)
    let matchCount = 0;
    let matchedWords = [];
    const altTextArrCopy = [...altTextArr]; // Create a copy to avoid modifying the original array

    variantOptionsArr.forEach((option) => {
      if (altTextArrCopy.includes(option)) {
        matchCount++;
        matchedWords.push(option);
        altTextArrCopy.splice(altTextArrCopy.indexOf(option), 1); // Remove matched word to prevent double counting
      }
    })
    console.log('chavi match count:', matchCount, 'chavi matched words:', matchedWords);
    return { matchCount, matchedWords };
  }

  /**
     * Checks if the image alt text is ONLY a color
     * and that color matches the current variant.
     *
     * This is used so images with alt text like:
     * "WHITE", "GREY", or "NATURAL OAK"
     *
     * can still show as secondary/additional images
     * for matching color variants.
     */
  isColorOnlyAltMatch(variantOptionsArr, altWords) {
    const colorOptions = ["WHITE", "NATURAL OAK", "GREY"];

    return (
      // Alt text must only have one processed value
      altWords.length === 1 &&

      // That one value must be one of our approved color-only alts
      colorOptions.includes(altWords[0]) &&

      // The current variant must include that same color
      variantOptionsArr.includes(altWords[0])
    );
  }

  getBestMatchingAltArray(product, variant) {
    if (!product.media || product.media.length === 0) return product.title;

    let altAnalysis = [];
    let variantOptionsArr = [];

    // 1. Prepare Variant Options once
    if (variant) {
      const variantOptions = [variant.option1, variant.option2, variant.option3];
      // console.log('chavi variant options:', variantOptions)
      variantOptionsArr = this.processVariantOptions(variantOptions);
      // console.log('chavi Processed variant options for matching:', variantOptionsArr);
    }

    // 2. Process all media and get scores
    for (let image of product.media) {
      const originalAlt = image.alt || product.title;
      const cleanedAltText = originalAlt.toUpperCase().trim();

      // Process the alt text into cells (handling the special phrases)
      const altWords = this.processAltText(cleanedAltText);
      // console.log(`chavi Original Alt: "${originalAlt}" - Processed Alt Words:`, altWords);

      // Get the match results
      const result = this.findBestMatchingAlt(variantOptionsArr, altWords);
      // console.log(`chavi Alt: "${originalAlt}" - Match Count: ${result.matchCount}`);

      /** Special case: If the alt text is ONLY a color,and the current variant has that color, we mark it so it can be included later.*/
      const isColorOnlyMatch = this.isColorOnlyAltMatch(
        variantOptionsArr,
        altWords
      );

      altAnalysis.push({
        original: originalAlt,
        matchCount: result.matchCount,
        isColorOnlyMatch
      });
    }

    // 3. Find the highest score
    const maxScore = Math.max(...altAnalysis.map(a => a.matchCount));

    // 3a. Add all alts with the max score to an array which will be passed into the updateThumbnailsVisibility function to determine which thumbnails to show/hide
    const bestMatchingAlts = [];
    altAnalysis.forEach(a => {
      if (a.matchCount === maxScore) {
        bestMatchingAlts.push(a.original);
      }
      else if (a.isColorOnlyMatch) {
        bestMatchingAlts.push(a.original);
      }
    });
    // console.log('Best matching alts for thumbnails visibility:', bestMatchingAlts);
    // return the list of best matching alts to be used in updateThumbnailsVisibility to determine which thumbnails to show/hide
    return bestMatchingAlts;
  }

  getFirstAlt(product, variant) {
    const allMatchingAlts = this.getBestMatchingAltArray(product, variant);
    if (allMatchingAlts.length > 0) {
      // Find the first item that hit the max score
      const winner = allMatchingAlts[0];
      return winner;
    } else {
      // FALLBACK: If no matches were found at all (maxScore is 0)
      // Return the alt of the first image
      return product.media[0].alt || product.title;
    }
  }

  updateMedia(product, variant) {
    console.log('in update media func');

    const altMatches = this.getBestMatchingAltArray(product, variant);

    this.updateThumbnailsVisibility(product, variant);
    if (altMatches && altMatches.length > 0) {
      this.setMediaInSlider(product.media.filter(image => altMatches.includes(image.alt)));
    }
    else {
      this.setMediaInSlider(product.media);
    }
  }

  updateThumbnailsVisibility(product, variant) {
    const altMatches = this.getBestMatchingAltArray(product, variant);
    // console.log('Updating thumbnails visibility with altMatches:', altMatches);
    Array.from(
      this.thumbnails.querySelectorAll(".product-media__thumbnails-item")
    ).forEach((thumbnail) => {
      const imgAlt = thumbnail.querySelector("img").getAttribute("alt") || "";
      //Check if the thumbnail's alt matches any of the best matching alts (which are in an array)
      if (altMatches && altMatches.length > 0) {
        const isExactMatch = altMatches.includes(imgAlt);
        if (isExactMatch) {
          thumbnail.style.display = "block";
        } else {
          thumbnail.style.display = "none";
        }
      }

    });
  }

  setMediaInSlider(media) {
    // console.log('in set media in slider');
    this.slider.removeAllSlides();

    // Load each image and update the slider as soon as it's loaded
    media.forEach((image, index) => {
      const img = new Image();
      img.src = image.src;
      img.alt = image.alt;

      img.onload = () => {
        const slide = document.createElement("div");
        slide.className = "swiper-slide";
        slide.setAttribute("data-sliderIndex", index);
        slide.appendChild(img);

        // Add Made In USA label for each image.
        this.appendMadeInUSALabel(slide);

        this.slider.appendSlide(slide);

        // Attach event listener to image click event
        img.addEventListener("click", () => {
          this.openPhotoSwipe(index, media);
        });

        // Update the slider for each loaded image
        this.slider.update();

        // Show the Swiper pagination after the first image is loaded
        if (index === 0) {
          const swiperPagination = this.media.querySelector(
            ".swiper-media-pagination"
          );
          if (swiperPagination) {
            swiperPagination.style.display = "block";
          }
        }
      };
    });
  }

  openPhotoSwipe(index, media) {
    let pswpElement = document.querySelectorAll(".pswp")[0];

    // Build items array based on the media provided
    let items = media.map((img) => {
      return { src: img.src, w: parseInt(img.width), h: parseInt(img.height) };
    });

    // Define PhotoSwipe options
    let options = {
      index: index, // Start on the slide that was clicked
      history: false, // If set to true the gallery will add a history record when PhotoSwipe is open. Works with URL change via hash (#) as well.
    };

    let gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      items,
      options
    );
    gallery.init();
  }
  // Add this new method
  appendMadeInUSALabel() {
    // console.log("starting appendMadeInUSALabel");
    const madeInUSADiv = document.createElement("div");
    madeInUSADiv.className = "made-in-use-label";

    const madeInUSASvg = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );
    madeInUSASvg.setAttribute("width", "117");
    madeInUSASvg.setAttribute("height", "20");

    const svgImage = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "image"
    );
    svgImage.href.baseVal =
      "https://cdn.shopify.com/s/files/1/0857/4644/files/made_in_the_usa_image_label.svg?v=1679933211";
    svgImage.setAttributeNS(null, "width", "117");
    svgImage.setAttributeNS(null, "height", "20");

    madeInUSASvg.appendChild(svgImage);
    madeInUSADiv.appendChild(madeInUSASvg);

    // const slides = document.querySelectorAll(
    //   ".product-media__images .swiper-slide"
    // );
    const slides = document.querySelectorAll(
      'div[data-version="new"] .product-media__images .swiper-slide'
    );

    slides.forEach((slide) => {
      slide.prepend(madeInUSADiv);
    });
  }

  /**
   * Extracts the variant ID from the URL.
   *
   * @returns {string|null} The variant ID if it exists, otherwise null.
   */
  getVariantIdFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("variant");
  }
}

if (!customElements.get("component-product-media")) {
  customElements.define("component-product-media", productMediaComponent);
}
